/* PattePlanet : page panier. Le formulaire fonctionne sans JS ; ici on soumet à la modification de quantité. */
(function () {
  'use strict';
  function boot() {
    var form = document.querySelector('[data-cart-page-form]');
    if (!form) return;
    var timer = null;
    var busy = false;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]') || busy) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        busy = true;
        form.setAttribute('aria-busy', 'true');
        form.submit();
      }, 450);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
